import { useState } from 'react';
import CharacterCreationPage from './CharacterCreationPage';
import Dashboard from './Dashboard';
import { useAuthStore } from '@/stores/auth';
import { useCharacter } from '@/hooks/useCharacter';

/**
 * /game is gated by ProtectedRoute (authenticated + email confirmed). Here
 * we branch on whether a character exists: no character means the player
 * has just signed up and needs to go through creation; a character means
 * we render the dashboard.
 *
 * The "just finished creating" state uses a local flag so we keep the
 * transition stage mounted until it tells us it's done, even after the
 * character row has been set in the auth store.
 */
export default function GamePage(): JSX.Element {
  const character = useCharacter();
  const refreshCharacter = useAuthStore((s) => s.refreshCharacter);
  const [creationDone, setCreationDone] = useState(false);

  if (!character && !creationDone) {
    return (
      <CharacterCreationPage
        onComplete={() => {
          // Re-fetch so we have the canonical row (with server defaults),
          // then unblock the dashboard render.
          void refreshCharacter();
          setCreationDone(true);
        }}
      />
    );
  }

  return <Dashboard />;
}
